import {
    useGetDMaxCommon,
    type Aside1DmaxInfoResponse,
    type Aside2DmaxInfoResponse,
    type SpecialDmaxInfoResponse,
} from "@/shared/server";
import { Center, Spinner, Text } from "@chakra-ui/react";
import { useParams } from "react-router-dom";
import { Aside1Section, Aside2Section, OtherSpecial, SpecialDetail } from "../common";
import { TopSection } from "../common/components/topSection";

export const Specials = () => {
    const { specialIdx } = useParams<string>();
    const { data: Dmax } = useGetDMaxCommon<SpecialDmaxInfoResponse>({ section: "special" });
    const { data: aside1 } = useGetDMaxCommon<Aside1DmaxInfoResponse>({ section: "aside1" });
    const { data: aside2 } = useGetDMaxCommon<Aside2DmaxInfoResponse>({ section: "aside2" });
    const targetSpecial = Dmax?.specials.find((t) => t.special_idx === specialIdx);
    const sector = {
        main: {
            firstLine: targetSpecial?.special_name.eng || "",
            secondLine: targetSpecial?.special_name.kor || "",
        },
        sub: {
            firstLine: "",
            secondLine: "",
        },
    };

    const otherSpecialList = Dmax?.specials.filter((t) => t.special_idx !== specialIdx);

    if (!specialIdx) {
        // 404로 요청
        return <div>404로 요청합니다</div>;
    }

    return targetSpecial && aside1 && aside2 && otherSpecialList ? (
        <>
            <TopSection sector={sector} imgList={targetSpecial.imgList} color="#fff" />
            <SpecialDetail data={targetSpecial} />
            <OtherSpecial specials={otherSpecialList} />
            <Aside1Section data={aside1} />
            <Aside2Section data={aside2} />
        </>
    ) : (
        <Center h="100vh" columnGap="8px">
            <Text>LOADING</Text>
            <Spinner />
        </Center>
    );
};
